//MARK: Done
import makeApiRequest from "./clients/apiRequest";
import { gateway } from "./clients/baseClient";
import { versionApiPath } from "./common";
import { ENDPOINTS } from "./endpoints";
import { ResponseData } from "./types/api";
import { AuditPageReqBody } from "./types/audit";

export async function auditPage(
    body: AuditPageReqBody
  ): Promise<ResponseData> {
    const data = {
      endpoint: `${versionApiPath}/${ENDPOINTS.AUDIT.PAGE}`,
      body: body,
    };
    return await makeApiRequest(
      {
        url: ``,
        method: "post",
        data: data,
      },
      gateway,
      false
    );
  }